
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/app/redirect",
      function () {
        return require("private-next-pages/payment/app/redirect.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/app/redirect"])
      });
    }
  